<template>
    <footer class="footer">
        <div class="columns">
            <div class="column">
                <div class="copyright-container">
                    <a href="https://uwclassy.com">
                        <img id="logo" src="@/assets/branding/classy.svg" />
                    </a>
                    <div class="copyright">
                        <span> © 2020 Classy </span>
                    </div>
                </div>
                <h6>Student made, student servicing platform for course insights</h6>
            </div>
            <div class="column mobile-hidden">
                <div class="navbar-end">
                    <div class="navbar-item">
                        <a class="navtext" @click="toggleModal">Rate a Class</a>
                    </div>
                    <div class="navbar-item">
                        <a class="navtext" target="_blank" href="https://forms.gle/egsbkbSQS3QPXhDD9"
                            >Give us Feedback</a
                        >
                    </div>
                </div>
            </div>
        </div>
        <RatingSelectionModal :isOpen="this.modalOpen" v-on:toggleModal="toggleModal" />
    </footer>
</template>

<script>
import RatingSelectionModal from "@/components/modals/RatingSelectionModal";

export default {
    name: "Footer",

    data() {
        return {
            modalOpen: false,
        };
    },

    components: {
        RatingSelectionModal,
    },

    methods: {
        toggleModal() {
            this.modalOpen = !this.modalOpen;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.footer {
    padding-left: 10%;
    padding-right: 10%;
}

#logo {
    height: 28px;
    width: auto;
}

.copyright {
    height: 28px;
    margin-left: 24px;
    line-height: 28px;
}

.copyright-container {
    display: flex;
}

.navtext {
    font-size: 16px;
    color: #000000;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        color: #666;
    }
}

@media only screen and (max-width: $breakpoint-medium) {
    .mobile-hidden {
        display: none;
    }
}
</style>
